import { format } from "date-fns"

export const TIME_ZONE = Intl.DateTimeFormat().resolvedOptions().timeZone

/** Через час, ровно в начале часа: разумное время по умолчанию для расписания. */
export const defaultSendAt = () => format(new Date(Date.now() + 60 * 60_000), "yyyy-MM-dd'T'HH:00")
